import { UserForm } from 'components/users/UserForm/UserForm'
import { useParams } from 'react-router-dom'

export const EditUser: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <UserForm mode='edit' userId={id ?? ''} />
}
